export const defaultEmailTemplateTypes = { insuranceRequestDefaultTemplate: 'insuranceRequestDefaultTemplate' };

export const defaultEmailBody = {
  templateInfo: {
    subjectHtml: '{{cert_holder_company_name}} : Insurance Certificate Status Notification',
    html: '<p>This is a reminder from {{cert_holder_company_name}} to notify you that insurance policies for the job {{job_name}} have expired or are about to expire.</p>'
            + '<p>The following policies are expired or are about to expire:</p>'
            + '<br />'
            + '<p>{{{expired_policies}}}</p>'
            + '<br />'
            + '<p><strong>We have automated our insurance certificate tracking using PINS Advantage.</strong></p>'
            + '<p>You or your agent will need to provide us with the insurance certificate and any associated documentation.</p>'
            + '<br />'
            + '<p><strong>Please forward this email to whomever is handling your insurance.</strong></p>'
            + '<br />'
            + '<p>Click the button below to submit the insurance certificate for {{insured_company_name}}:</p>'
            + '<br />'
            + '<p>{{{agent_portal_button}}}</p>'
  },
  templateName: 'Default Insurance Request'
};

export const insuranceRequestDefaultTemplate = {
  templateInfo: {
    subjectHtml: '{{cert_holder_company_name}} is Requesting Your Insurance',
    html: '<p>Dear {{insured_company_name}},</p>'
      + '<br />'
      + '<p>{{cert_holder_company_name}} is requesting proof of insurance for {{project_name}}.</p>'
      + '<br />'
      + '<p>We have automated our insurance certificate tracking using PINS Advantage.  Your agent will need to provide us with the insurance certificate and any associated documentation.</p>'
      + '<br />'
      + '<p><strong>Please forward this email to whomever is handling your insurance.</strong></p>'
      + '<br />'
      + '<p>Click the button below to submit the insurance certificate for {{insured_company_name}}:</p>'
      + '<br />'
      + '<p>{{{agent_portal_button}}}</p>'
  },
  templateName: 'PINS - Insurance Request Template',
  templateType: 'main_content',
  templateId: null,
  companyId: null,
  departmentId: null,
  userId: null
};

export const getAgentEditPolicyDefaultTemplate = agentName => ({
  templateInfo: {
    subjectHtml: '{{cert_holder_company_name}} is Requesting Modifications to Your Certificate',
    html: `<p>Dear ${agentName},</p>`
        + '<br />'
        + '<p>{{cert_holder_company_name}} is requesting changes to your recent PINS certificate submission for {{project_name}}.</p>'
        + '<br />'
        + '<p>Click the link below to edit your submission:</p>'
        + '<br />'
        + '<p>{{{agent_portal_button}}}</p>'
  },
  templateName: 'PINS - Request Policy Modification Template',
  templateType: 'main_content',
  templateId: null,
  companyId: null,
  departmentId: null,
  userId: null
});

export const defaultEmailSignature = {
  templateInfo: {
    html: '<p>Thank you,</p>'
            + '<br />'
            + '<p>{{user_name}}</p>'
            + '<p>{{user_email}}</p>'
            + '<p>{{user_phone}}</p>'
            + '<p>{{cert_holder_company_name}}</p>'
  },
  templateName: 'Default Signature'
};
